import { Phone, Mail, Calendar, Building2, MessageSquare, FileText, Activity } from 'lucide-react';

/**
 * Default icon/color mapping for known activity types.
 * Unknown/custom types fall back to a generic Activity icon.
 */
const KNOWN_TYPES = {
  call: { icon: Phone, color: '#3B82F6', bg: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
  email: { icon: Mail, color: '#8B5CF6', bg: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400' },
  meeting: { icon: Calendar, color: '#F59E0B', bg: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' },
  visit: { icon: Building2, color: '#10B981', bg: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  message: { icon: MessageSquare, color: '#EC4899', bg: 'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-400' },
  note: { icon: FileText, color: '#6B7280', bg: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400' },
};

const FALLBACK = { icon: Activity, color: '#6B7280', bg: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400' };

export function getActivityTypeConfig(type) {
  return KNOWN_TYPES[type] || FALLBACK;
}

export function getActivityIcon(type) {
  return (KNOWN_TYPES[type] || FALLBACK).icon;
}

export function getActivityColor(type) {
  return (KNOWN_TYPES[type] || FALLBACK).color;
}

export function getActivityBg(type) {
  return (KNOWN_TYPES[type] || FALLBACK).bg;
}
